import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { visuallyHidden } from '../theme/utils';

const FormControl = styled.div`
  margin-bottom: ${props => props.theme.spacing.medium};
  width: 100%;

  ${props =>
    props.noMargin &&
    `
    margin-bottom: 0;
    
  `}
`;

const Field = styled.div`
  ${props =>
    props.inline &&
    `
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-end;
    
  `}
`;

const Label = styled.label`
  display: block;
  margin-bottom: ${props => props.theme.spacing.xxSmall};
  font-size: ${props => props.theme.fontSizes.base};

  ${props =>
    props.hideLabel &&
    `
    ${visuallyHidden}
  `}
`;

const ErrorMessage = styled.p`
  font-size: ${props => props.theme.fontSizes.xSmall};
  padding: ${props => props.theme.spacing.xxSmall} 0;
  margin: 0;
  color: ${props => props.theme.colors.red500};
`;

const HintText = styled.p`
  font-size: ${props => props.theme.fontSizes.xSmall};
  padding: ${props => props.theme.spacing.xxSmall} 0;
  margin: 0;
  color: ${props => props.theme.colors.black50};
`;

function FieldWrapper({
  label,
  children,
  errorMessage,
  hintText,
  name,
  inline,
  hideLabel,
  noMargin,
  hideErrorMessage,
}) {
  return (
    <FormControl inline={inline} noMargin={noMargin}>
      <Field inline={inline}>
        <Label htmlFor={name} hideLabel={hideLabel}>
          {label}
        </Label>

        {children}
      </Field>

      {!!(errorMessage && !hideErrorMessage) && (
        <ErrorMessage error>{errorMessage}</ErrorMessage>
      )}

      {hintText && <HintText>{hintText}</HintText>}
    </FormControl>
  );
}

FieldWrapper.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  hintText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  children: PropTypes.node.isRequired,
  inline: PropTypes.bool,
  hideLabel: PropTypes.bool,
  noMargin: PropTypes.bool,
  hideErrorMessage: PropTypes.bool,
};

FieldWrapper.defaultProps = {
  hintText: null,
  errorMessage: null,
  inline: false,
  hideLabel: false,
  noMargin: false,
  hideErrorMessage: false,
};

export default FieldWrapper;
